import type { ComponentType } from "react";
import VideoPlayerSideBar from "../VideoPlayerSideBar";
import { AudienceLayerPanel } from "../../../components/AudienceLayerPanel";
import type { AudienceLayerHostContext } from "./useAudienceLayerHost";

// The sidebar destructures its props inline without declaring a type, so it
// has no props signature to spread into. Naming that here keeps the cast in
// one place instead of at each use.
const LegacySidebar = VideoPlayerSideBar as unknown as ComponentType<Record<string, unknown>>;

type Props = {
  audienceLayerEnabled: boolean;
  audienceLayerHost: AudienceLayerHostContext | null;
  // Everything else goes straight through to the sidebar this may replace.
  // Deliberately loose: that component takes upwards of forty untyped props,
  // and re-declaring them here would be a second list to keep in step with
  // the first for no benefit, since this component reads none of them.
  [key: string]: unknown;
};

/**
 * Chooses which sidebar the Watch page shows, so the three places that render
 * one do not each carry the same conditional around forty-odd props.
 *
 * The Audience Layer wins where it is switched on for the tenant and somebody
 * is signed in. Everywhere else, and if the remote fails to load at all, the
 * existing sidebar renders exactly as before: this replaces the sidebar, so a
 * remote that cannot load must not take the chat down with it.
 */
export function WatchSidebar({ audienceLayerEnabled, audienceLayerHost, ...sidebarProps }: Props) {
  return (
    <AudienceLayerPanel
      enabled={audienceLayerEnabled}
      hostContext={audienceLayerHost}
      fallback={<LegacySidebar {...sidebarProps} />}
    />
  );
}
